module.exports = __webpack_public_path__ + "img/interPersonal2.af9a5ef9.png";